<template>
  <div v-if="items.length" class="active-table-filters">
    <span v-if="label" class="active-table-filters__label">{{ label }}</span>
    <a-tag
      v-for="item in items"
      :key="item.key"
      class="active-table-filters__tag"
      :closable="item.closable !== false"
      @click="handleEdit(item)"
      @close="event => handleRemove(event, item)"
    >
      <span class="active-table-filters__tag-label">{{ item.label }}:</span>
      <span>{{ item.value }}</span>
    </a-tag>
    <a-button v-if="showReset" size="small" class="active-table-filters__reset" icon="undo" @click="$emit('reset')">
      Reset Filters
    </a-button>
  </div>
</template>

<script>
import { Button, Tag } from 'ant-design-vue'

export default {
  name: 'ActiveTableFilters',
  components: {
    'a-button': Button,
    'a-tag': Tag
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    items: {
      type: Array,
      default: () => []
    },
    showReset: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleEdit(item) {
      this.$emit('edit', item)
    },

    handleRemove(event, item) {
      event?.preventDefault?.()
      event?.stopPropagation?.()
      this.$emit('remove', item)
    }
  }
}
</script>

<style scoped>
.active-table-filters {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  padding: 0 0 10px;
}

.active-table-filters__label {
  color: var(--text-color-secondary);
  font-size: 13px;
  line-height: 24px;
}

.active-table-filters__tag {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  max-width: 320px;
  margin: 0;
  cursor: pointer;
}

.active-table-filters__tag-label {
  font-weight: 600;
}

.active-table-filters__reset {
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
